var map = {
	"./TW.png": "0d5a",
	"./bah.png": "fc6e",
	"./derman.png": "a986",
	"./deu.png": "915c",
	"./en-uk.png": "26ac",
	"./en-us.png": "1824",
	"./en.png": "b54c",
	"./enuk.png": "ca31",
	"./enus.png": "1dcd",
	"./fra.png": "343a",
	"./french.png": "0a34",
	"./hindi.png": "6af1",
	"./jap.png": "d09b",
	"./jap1.png": "49d1",
	"./kr.png": "ce25",
	"./tai.png": "efdf",
	"./urdu.png": "cfac",
	"./vit.png": "23cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f6f8";